// extracted by mini-css-extract-plugin
export default {"drawer_body":"QurealSidebarMobile_drawer_body__k8yKt"};